/**
 * Which game UIs this client can render; the browser's mirror of `server/src/games.ts`.
 * whittle: static map puts every game in every bundle; move to `React.lazy` per surface
 * when `scripts/check-budgets.mjs` complains.
 */

import type { GameUi } from './kit/game';
import { jeopardyUi } from '@games/jeopardy/ui';
import { applesUi } from '@games/apples-to-apples/ui';

/** Keyed by the `gameId` a segment names. */
const GAME_UI: Readonly<Record<string, GameUi>> = {
  jeopardy: jeopardyUi,
  'apples-to-apples': applesUi,
};

/**
 * Null is a real state: no segment (lobby, interstitial, results), or a game this build
 * lacks (a tab left open across a deploy).
 */
export function uiFor(gameId: string | null | undefined): GameUi | null {
  return gameId ? (GAME_UI[gameId] ?? null) : null;
}
